<div cdkDropListGroup class="div3">
  <div class="example-container left" >
    <h2>Disponíveis</h2>

    <div
      cdkDropList
      [cdkDropListData]="availableColumns"
      class="example-list"
      (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let item of availableColumns" cdkDrag>{{item.columnDesc|translateTA}}</div>
    </div>
  </div>


  <div class="example-container right">
    <h2>Ativos</h2>

    <div
      cdkDropList
      [cdkDropListData]="displayedColumns"
      class="example-list"
      (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let item of displayedColumns" cdkDrag>{{item.columnDesc|translateTA}}</div>
    </div>
  </div>
</div>
<nz-divider></nz-divider>
<div class="btnConfCancel">
  <button nz-button nzType="text" (click)="addall()">Ativar Campos</button>
  <button nz-button nzType="text" (click)="removeall()">Inativar Campos</button>
  <button nz-button nzType="text" (click)="confirm()"><nz-icon nzType="check"></nz-icon></button>
  <button nz-button nzType="text" (click)="closeGrid()"><nz-icon nzType="close"></nz-icon></button>
</div>
